let html = `<div class="extensions">
    <div class="extensions__body"></div>
</div>`

export default html